module.exports = __webpack_public_path__ + "img/ayuda-figura1-poligonos.edaed232.png";